var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV21SoccerBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.25C11.7279 15.25 14.75 12.2279 14.75 8.5C14.75 4.77208 11.7279 1.75 8 1.75C4.27208 1.75 1.25 4.77208 1.25 8.5C1.25 12.2279 4.27208 15.25 8 15.25Z",
    fill: "white",
    stroke: "#E11D48",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5L4.75 7L6 10.75H10L11.25 7L8 4.5Z",
    fill: "#E11D48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 8.5C1.25 8.55442 1.25293 8.60815 1.25411 8.66227L3.74473 6.955L2.73281 4.10817C1.76904 5.36923 1.24787 6.91283 1.25 8.5Z",
    fill: "#E11D48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8.5C14.7521 6.91283 14.231 5.36923 13.2672 4.10817L12.2553 6.955L14.7459 8.66237C14.7471 8.60815 14.75 8.55442 14.75 8.5Z",
    fill: "#E11D48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54098 12.6278L5.56098 12.5451L6.41598 15.4445C4.8429 14.9709 3.47687 13.978 2.54098 12.6278Z",
    fill: "#E11D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.459 12.6278L10.439 12.5451L9.584 15.4445C11.1571 14.9709 12.5231 13.978 13.459 12.6278Z",
    fill: "#E11D48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10423 1.6571L8.50001 3.5L10.8958 1.6571C9.34472 1.1143 7.6553 1.1143 6.10423 1.6571Z",
    fill: "#E11D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV21SoccerBall);
export default __webpack_public_path__ + "static/media/v21-soccer-ball.31bae3ad76e66df95c81ef803a826bcd.svg";
export { ForwardRef as ReactComponent };